import React, { createContext, useContext, useState, useMemo, useEffect, useCallback } from 'react';
import doFetch from '../../api/doFetch';

const context = createContext();

export default function ({ children }) {
  const [currentPartner, setCurrentPartner] = useState();
  const [isLoading, setIsLoading] = useState(false);
  const [partners, setPartners] = useState([]);

  const reloadData = async () => {
    setIsLoading(true);

    const partners = await doFetch(`/lotlenz/partners`);
    setPartners(partners);
    setIsLoading(false);
  };

  useEffect(() => {
    reloadData();
  }, []);

  const contextValue = useMemo(
    () => ({ partners, isLoading, currentPartner, setCurrentPartner, reloadData }),
    [partners, isLoading, currentPartner]
  );

  return (
    <>{contextValue && <context.Provider value={contextValue}>{children}</context.Provider>}</>
  );
}

export const usePartners = () => {
  return useContext(context)?.partners;
};

export const useIsLoading = () => {
  return useContext(context)?.isLoading;
};

export const useCurrentPartner = () => {
  return useContext(context)?.currentPartner;
};

export const useSetCurrentPartner = () => {
  const { setCurrentPartner } = useContext(context);

  return useCallback((partner) => setCurrentPartner(partner), [setCurrentPartner]);
};

export const useReloadPartners = () => {
  const { reloadData } = useContext(context);

  return useCallback(() => {
    reloadData().then(() => null);
  }, [reloadData]);
};
